import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const AmexMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4009" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="#0079C1"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4009)"
      />
      <Path
        d="M10.0629 11.5L6 20.4884H10.8639L11.4668 19.0553H12.8451L13.4481 20.4884H33.6596L35.0135 19.0925L36.2812 20.4884L42 20.5L37.9243 16.0193L42 11.5H36.3699L35.052 12.8701L33.8242 11.5H21.7115L20.6714 13.82L19.6069 11.5H14.7532V12.5566L14.2132 11.5H10.0629ZM11.004 12.7764H13.3749L16.0698 18.8715V12.7764H18.667L20.7485 17.1465L22.6669 12.7764H25.2511V19.2262H23.6786L23.6658 14.1721L21.3733 19.2262H19.9667L17.6614 14.1721V19.2262H14.4266L13.8133 17.7802H10.5L9.88803 19.2249H8.15483L11.004 12.7764ZM26.6897 12.7764H33.0836L35.0391 14.8881L37.0577 12.7764H39.0133L36.042 16.018L39.0133 19.2224H36.969L35.0135 17.0861L32.9846 19.2224H26.6897V12.7764ZM12.1574 13.8676L11.0658 16.4435H13.2477L12.1574 13.8676ZM28.2686 14.1118V15.2892H31.7568V16.6015H28.2686V17.8869H32.1811L33.999 15.9937L32.2582 14.1107H28.2686V14.1118Z"
        fill="white"
      />
    </Svg>
  )
}
